/* eslint-disable no-nested-ternary */
import {
  DECIMAL_ODDS,
  AMERICAN_ODDS,
  FRACTIONAL_ODDS,
} from 'constants/bcms';
import decimalOdds from './decimal';
import { americanOdds } from './american';
import fractionalOdds from './fractional';

const formatOdds = (num, format) => {
  if (format === DECIMAL_ODDS) {
    return decimalOdds(num);
  } else if (format === AMERICAN_ODDS) {
    return americanOdds(num);
  } else if (format === FRACTIONAL_ODDS) {
    return fractionalOdds(num);
  }

  return null;
};

export default formatOdds;
